<template>
  <ModalPlay v-if="!state.loading" size="sm" :title="course?.title || $t('module.no_access')" @close="emit('close')">
    <div v-if="course?.title && course.cover" class="tw:flex tw:flex-row tw:gap-4">
      <img :src="course?.cover.cdn_url ? course.cover.cdn_url : {}" class="tw:w-[240px] tw:h-auto tw:object-cover tw:rounded-lg tw:flex-shrink-0" />
      <div class="tw:flex tw:flex-col tw:gap-4 tw:flex-1 tw:justify-center">
        <div class="tw:flex tw:flex-col tw:gap-2">
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
          <TextPlay v-if="courseSale?.sale_description" v-html="courseSale.sale_description" />
          <div v-else class="modalContent__cta--description">
            <TextPlay :text="$t('module.first_paragraph')" />
            <TextPlay :text="$t('module.second_paragraph')" />
          </div>
        </div>
        <ButtonPlayV2 v-if="courseSale?.sale_button_txt && courseSale?.sale_link" variant="filled" :text="courseSale.sale_button_txt" @click="openUrlAction(courseSale.sale_link)" />
      </div>
    </div>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { useHomeLegacyStore } from "@/store/home-legacy.store";
import { ID, play } from "@voomp/play-back";
import { onMounted } from "vue";
import { ref, reactive } from "vue";
import { TextPlay, ModalPlay } from "@/components/atomic"


const props = withDefaults(defineProps<{
  courseId: ID;
}>(), {});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const homeLegacyStore = useHomeLegacyStore();

const courseSale = ref<{ description?: string; button?: string; link?: string } | null>(null);
const course = ref<{ title?: string; cover?: { cdn_url?: string } }>({});

const state = reactive({
  loading: false,
});

async function fetchCourse() {
  try {
    state.loading = true;
    const [_courseSale, _course] = await Promise.all([
      homeLegacyStore.actionFetchCourseAvailability(props.courseId),
      play.course.find({ idCourse: props.courseId }),
    ]);
    courseSale.value = _courseSale;
    course.value = _course;
  } catch (error) {
    console.error(error);
  } finally {
    state.loading = false;
  }
}

onMounted(() => {
  fetchCourse();
});

function openUrlAction(url: string) {
  return window.open(url, '_blank');
}

</script>
